import React from "react";
import logo from "../assets/Redlane-Logo.png";
import circeRegular from "../assets/CirceRounded-Regular_400.otf";

// Optional: for a true bold weight, add CirceRounded-Bold.otf to assets,
// uncomment the import below and replace `null` with `circeBold`.
// Without it, the browser synthesises bold from the regular font.
// import circeBold from "../assets/CirceRounded-Bold.otf";
const CIRCE_BOLD_URL = null;

// Circe Rounded has no ₦ glyph, so (as in the design) ₦ comes from Noto Sans.
// These are tiny subsets containing only U+20A6.
// Noto Sans © The Noto Project Authors — SIL Open Font License 1.1.
const NAIRA_REGULAR_URI =
  "data:font/woff2;base64,d09GMgABAAAAAAKsAA0AAAAABcgAAAJbAAID1wAAAAAAAAAAAAAAAAAAAAAAAAAAGyAcNgZgADQRCAqBAIEUATYCJAMICwYABCAFhUoHIBvxBBEVlL0UPxN4E62TEKHOBcCKz1af8HIlVST+NMfD/4/V7vvz12YQUwnNJJK30pZK5BBFJIomJgAW5gZe6uLF4xsi0q676X6gkf3T/j9/M/5WNikbEwONNMG1/QF+amgULaJEjsbC8wnYnZ+enrqpIujjIchWRihh5Ch5qUBROx3EtBnzlqmWoVwGBIqGGCZD/9Rm6+/IPt12Vtv36rbPOnZAt9x1kNPkuKKCdC69Mfex2thgSEwhlSpSrsgpZUACmLlw4Ux3oLZTbRb/v8jb4jwCUqt0j04yEgpopiCaMeuE3A461ZbL0/RmrYAoPm5pCBLIqEA/jKSdhIp2OedcKhSjFJssLeeVFKlUXCOsKa0ors6Wj8qqWDBpwZLe+Rts+NP+Pf19fe/YvcGJiPt9ep8dVNTf0H7x9NbiWSzeuKEip6N9gEAqPBncbfgko+G439Xjwle8+veFD86d265/tvgt86iUQFBVWWqFEG642Q8BQEqrbEjjFAVSZK3sUCkAQBaoskZB5BrUCZTQRJ2SNHBXybp4rFTq5J9SP7pEq7U2MCJ59Vle/KrQDwg0RdPgHiAcc8rhXOUROgSThoK8qoEhnaSi1mXZD7FLjS05eSpn3Fd5eUa1nFgUZqJfIcaiI/llkoQOK3XyZmX1Ff2GNFVBc2D53UrE9yBMZ0tNgJs00AfjEDw1M2Y1ulETIBdVGRX5622zh1OBGX+45yAheTKgDkEMqnQ5Zvp/95Ww1VqVbbPsBOFjAsAaMLkEy6SDN6id0pPCTiKpQCKZ3gRfPi33Wegfu/JNDQAA";
const NAIRA_BOLD_URI =
  "data:font/woff2;base64,d09GMgABAAAAAALIAA0AAAAABbAAAAJ6AAID1wAAAAAAAAAAAAAAAAAAAAAAAAAAGyAcNgZgADQRCAp8gRQBNgIkAwgLBgAEIAWFOAcgG98EKJ4DbvN0xK6EUrlkGz5JGhLRycc/Hv5/v2/73Ll/zJNo0uShiUWTpjEbYolIp7Go7qHAS/PfX2u/vY9Z94eqnOzp2uy+j4fGEDolkSiBoWRv8Dx5e/vLBmFBFHGehcm6SxKII6iUTP/+VvypArv4xNAu0fOiP08jKirCgLJuSxs/dsF2LZCdVW/1kCIiutxNhvutAo36VLK2hbU9kitDWQICjab0yTSNlfY7zUjdrWmy6MdGUeVD9nPO05sK6csRYnU9LE49ZQlJrT7lSk4pAxLA4r65SF6GDs3t1Q/kK54QkNb0nDAkEwk16JYh0C3TECLLgqG/LEXx5ZQFXjzOHEECGRVMIuYRkAGVJe+yKRpjUE0bnCaNZOOh3m0HjfuyuWLEyNJkcbn2/6yQxbDhpYKLq9XreOYHVLHM3Op892Lvo/kxsbi49J+VcTyIQCDVN3d3H6ujkrF/9Tk1fwk+vS/+wI/+NG4eqw+Nf5ntLLUSCKJKmyYLefNser8EACnrjjMmXyB5aUZlCwCQBersyhBDA56g8KHTK5/Ue8Znfd75Wj0++ZYyErWPbzWXUbMk5Y4WCYQQ6NGlRw+wJ0SBDRKSwBZNilEuBKaloZCkGaBJCCHFGNGpUyCCQmmODi6J6yRg3+OTBGR0YmwoIrQLaBSVaOdS9jNMxNVM9a9dNsGYITHeux26XYn2rT2hiAEWmhzskny4YRMVwGaSFCjGowAM0grykC5QbD/btWwN2KRQAt9cw6C24AAhNyKSgG4dh5lD7Xeb6Zjtmi3C2BwMBW5iB2ALTNtWutEISAkMN2KsoNAdDGA6ch1CoNOmBWtekGEblRemAA==";

// ─── BRAND ────────────────────────────────────────────────────────────────────
const TITLE_RED = "#AA0000"; // "Invoice" heading
const BRAND_RED = "#81150D"; // table header (same red as the logo)
const INK       = "#000000";
const FONT_STACK = "'Circe Rounded', 'Naira Sign', 'Helvetica Neue', Arial, sans-serif";

// ─── AGENCY ───────────────────────────────────────────────────────────────────
const AGENCIES = {
  nigeria: {
    name:  "Redlane Travels Limited",
    email: "lane@redlanetravels.com",
    phone: "+23470777848741",
  },
  canada: {
    name:  "Redlane Travels Inc",
    email: "lane@redlanetravels.com",
    phone: "+14377225664",
  },
};

function getAgency(country = "") {
  const c = (country || "").toLowerCase().trim();
  if (c === "canada" || c === "ca") return AGENCIES.canada;
  return AGENCIES.nigeria;
}

// ─── TERMS ────────────────────────────────────────────────────────────────────
const TERMS = [
  "Any pending balance must be completed on or before the due date.",
  "Changes to flight dates or services may incur additional charges.",
  "Confirmed bookings are non-refundable.",
  "Cancellations and refunds are subject to the airline/vendor's refund policy.",
];

// ─── HELPERS ──────────────────────────────────────────────────────────────────
const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

const fmtMoney = (n, cur = "NGN") =>
  n != null && !isNaN(Number(n))
    ? new Intl.NumberFormat("en-NG", {
        style: "currency",
        currency: cur,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(Number(n))
    : "–";

// "29 August, 2026"
const fmtDate = (d) => {
  if (!d) return "–";
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return "–";
  return `${dt.getDate()} ${MONTHS[dt.getMonth()]}, ${dt.getFullYear()}`;
};

// ─── PRINT STYLES ─────────────────────────────────────────────────────────────
const getPrintStyles = (regularUrl, boldUrl) => `
  @font-face { font-family:'Circe Rounded'; src:url('${regularUrl}') format('opentype'); font-weight:400; font-style:normal; }
  ${boldUrl ? `@font-face { font-family:'Circe Rounded'; src:url('${boldUrl}') format('opentype'); font-weight:700; font-style:normal; }` : ""}
  @font-face { font-family:'Naira Sign'; src:url('${NAIRA_REGULAR_URI}') format('woff2'); font-weight:400; }
  @font-face { font-family:'Naira Sign'; src:url('${NAIRA_BOLD_URI}') format('woff2'); font-weight:700; }

  #invoice-print-root, #invoice-print-root * { box-sizing:border-box; margin:0; padding:0; }
  #invoice-print-root * {
    font-family:inherit; font-size:inherit; line-height:inherit; color:inherit;
    letter-spacing:normal; text-transform:none;
  }

  @media print {
    @page { margin: 0; size: A4; }
    body > *, body * { visibility: hidden !important; }
    #invoice-print-root, #invoice-print-root * { visibility: visible !important; }
    #invoice-print-root {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 794px !important;
      min-height: 0 !important;
      margin: 0 !important;
      background: #ffffff !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      z-index: 999999 !important;
    }
    body { overflow: visible !important; }
  }
`;

// ─── COMPONENT ────────────────────────────────────────────────────────────────
export default function InvoicePrintView({ invoice }) {
  const currency = invoice.currency || "NGN";
  const agency   = getAgency(invoice.country);
  const money    = (n) => fmtMoney(n, currency);

  const items      = invoice.items || [];
  const subtotal   = items.reduce((s, i) => s + Number(i.quantity || 0) * Number(i.unitPrice || 0), 0);
  const tax        = invoice.tax ?? 0;
  const total      = invoice.total ?? subtotal + tax;
  const amountPaid = invoice.amountPaid ?? invoice.paidAmount ?? 0;
  const pending    = invoice.pendingBalance ?? invoice.balance ?? Math.max(total - amountPaid, 0);

  const phone   = invoice.phone ?? invoice.clientPhone ?? invoice.phoneNumber ?? "";
  const dueDate = invoice.dueDate ?? invoice.createdAt;

  const bank = invoice.bankPaymentInfo || {};
  const paymentLines = [
    bank.accountNumber && <><B>Account No:</B> {bank.accountNumber}</>,
    bank.bankName      && <><B>Bank Name:</B> {bank.bankName}</>,
    bank.accountName   && <><B>Account Name:</B> {bank.accountName}</>,
    invoice.paymentReference && <><B>Payment Reference: </B>{invoice.paymentReference}</>,
    invoice.paystackPaymentLink && (
      <><B>Pay Online:</B> <span style={{ wordBreak: "break-all" }}>{invoice.paystackPaymentLink}</span></>
    ),
  ].filter(Boolean);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: getPrintStyles(circeRegular, CIRCE_BOLD_URL) }} />

      <div id="invoice-print-root" style={S.root}>

        <img src={logo} alt="Redlane" style={S.logo} />

        <h1 style={S.title}>Invoice</h1>

        {/* Invoice details  ←→  Agency */}
        <div style={S.meta}>
          <div>
            <p><B>Invoice Number: </B>{invoice.invoiceReference}</p>
            <p><B>Date Billed: </B>{fmtDate(invoice.createdAt)}</p>
            <p><B>Due Date</B>: {fmtDate(dueDate)}</p>
          </div>
          <div style={{ textAlign: "right" }}>
            <p><B>{agency.name}</B></p>
            <p>{agency.email}</p>
            <p>{agency.phone}</p>
          </div>
        </div>

        {/* Billed To */}
        <div style={S.party}>
          <p><B>Billed To:</B></p>
          <p>{invoice.clientName}</p>
          <p>{invoice.email}</p>
          <p>{phone || "\u00A0"}</p>
        </div>

        {/* Line items */}
        <div style={S.items}>
          <div style={{ ...S.row, ...S.itemsHead }}>
            <div style={S.cDesc}>DESCRIPTION</div>
            <div style={S.cQty}>QTY</div>
            <div style={S.cPrice}>UNIT PRICE</div>
          </div>

          <div style={S.itemsBody}>
            {items.map((item, idx) => (
              <div key={idx} style={{ ...S.row, ...S.item, marginTop: idx ? 12 : 0 }}>
                <div style={S.cDesc}><DescriptionCell text={item.description} /></div>
                <div style={S.cQty}>{item.quantity}</div>
                <div style={S.cPrice}>{money(item.unitPrice)}</div>
              </div>
            ))}
          </div>

          {/* Totals */}
          <div style={S.totals}>
            <TotalRow label="Total Cost:"     value={money(subtotal)} />
            <TotalRow label="Tax:"            value={money(tax)} />
            <TotalRow label="Amount Paid:"    value={money(amountPaid)} />
            <TotalRow label="Pending Balance" value={money(pending)} />
          </div>
        </div>

        {/* Payment Information */}
        {paymentLines.length > 0 && (
          <div style={{ ...S.section, marginTop: 33.83 }}>
            <p style={S.sectionTitle}>Payment Information</p>
            <Bullets items={paymentLines} />
          </div>
        )}

        {/* Terms */}
        <div style={{ ...S.section, marginTop: paymentLines.length ? 20.3 : 33.83 }}>
          <p style={S.sectionTitle}>Terms And Conditions:</p>
          <Bullets items={TERMS} />
        </div>

      </div>
    </>
  );
}

// ─── SMALL PIECES ─────────────────────────────────────────────────────────────
function B({ children }) {
  return <b style={{ fontWeight: 700 }}>{children}</b>;
}

function TotalRow({ label, value }) {
  return (
    <div style={S.row}>
      <div style={S.totalLabel}>{label}</div>
      <div style={S.totalValue}>{value}</div>
    </div>
  );
}

function Bullets({ items, style }) {
  return (
    <ul style={{ ...S.bullets, ...style }}>
      {items.map((content, i) => (
        <li key={i} style={S.li}>
          <span style={S.dot} />
          {content}
        </li>
      ))}
    </ul>
  );
}

// ─── DESCRIPTION CELL ─────────────────────────────────────────────────────────
// "•", "-" or a single "*" starts a bullet ("**bold**" does not)
const BULLET_RE = /^([•\-]|\*(?!\*))/;

function DescriptionCell({ text = "" }) {
  if (!text) return null;
  const introLines = [], bulletLines = [];
  let inBullets = false;
  text.split("\n").forEach((line) => {
    const t = line.trim();
    if (BULLET_RE.test(t)) {
      inBullets = true;
      bulletLines.push(t.replace(/^([•\-]|\*(?!\*))\s*/, ""));
    } else if (!inBullets) {
      introLines.push(t);
    } else if (t) {
      bulletLines.push(t);
    }
  });
  return (
    <div>
      {introLines.filter(Boolean).map((line, i) => (
        <p key={i}><FormattedText text={line} /></p>
      ))}
      {bulletLines.length > 0 && (
        <Bullets
          items={bulletLines.map((b, i) => <FormattedText key={i} text={b} />)}
          style={{ marginTop: 4 }}
        />
      )}
    </div>
  );
}

function FormattedText({ text }) {
  if (!text?.includes("**")) return <>{text}</>;
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return (
    <>
      {parts.map((part, i) =>
        part.startsWith("**") && part.endsWith("**")
          ? <B key={i}>{part.slice(2, -2)}</B>
          : <span key={i}>{part}</span>
      )}
    </>
  );
}

// ─── STYLE OBJECTS ────────────────────────────────────────────────────────────
// Measurements are taken from the design PDF (A4 = 794 × 1123 px).
const S = {
  root: {
    position:   "relative",
    width:      794,
    minHeight:  1123,
    margin:     "0 auto",
    background: "#ffffff",
    color:      INK,
    fontFamily: FONT_STACK,
    fontSize:   16,
    lineHeight: "22px",
    fontWeight: 400,
  },
  logo: {
    position: "absolute",
    top:      46,
    right:    65.5,
    width:    171.3,
    maxWidth: "none",
    height:   "auto",
    display:  "block",
  },
  title: {
    padding:    "46.96px 0 0 36.3px",
    fontSize:   66.68,
    lineHeight: "66.68px",
    fontWeight: 700,
    color:      TITLE_RED,
  },
  meta: {
    display:        "flex",
    justifyContent: "space-between",
    alignItems:     "flex-start",
    marginTop:      15,
    padding:        "0 65.13px 0 44.84px",
  },
  party:     { marginTop: 33.1, paddingLeft: 44.84 },
  items:     { margin: "32.5px 36px 0" },
  row:       { display: "flex", alignItems: "flex-start" },
  cDesc:     { width: 466, flexShrink: 0, padding: "0 16px 0 8.84px" },
  cQty:      { width: 80.2, flexShrink: 0, textAlign: "center" },
  cPrice:    { flex: 1, paddingLeft: 52.33, whiteSpace: "nowrap" },
  itemsHead: {
    paddingBottom: 2.97,
    borderBottom:  `1px solid ${INK}`,
    color:         BRAND_RED,
    fontWeight:    700,
  },
  itemsBody: {
    minHeight:    267,
    padding:      "14px 0 8px",
    borderBottom: `1px solid ${INK}`,
  },
  item:   { breakInside: "avoid", pageBreakInside: "avoid" },
  totals: {
    padding:         "2.53px 0 4.77px",
    borderBottom:    `1px solid ${INK}`,
    fontWeight:      700,
    lineHeight:      "34px",
    breakInside:     "avoid",
    pageBreakInside: "avoid",
  },
  totalLabel:   { width: 585.39, flexShrink: 0, textAlign: "right" },
  totalValue:   { paddingLeft: 13.14, whiteSpace: "nowrap" },
  section:      { padding: "0 65px 0 44.84px", breakInside: "avoid", pageBreakInside: "avoid" },
  sectionTitle: { fontWeight: 700 },
  bullets:      { listStyle: "none", marginTop: 7.3 },
  li:           { position: "relative", paddingLeft: 27.2, lineHeight: "23px" },
  dot: {
    position:     "absolute",
    left:         9.91,
    top:          7.87,
    width:        5,
    height:       5,
    borderRadius: "50%",
    background:   INK,
  },
};